import { Controller } from '@hotwired/stimulus';
import { application } from 'src/app';
import Cleave from 'cleave.js';
import {
  toggleClass,
  removeClass,
  addClass,
  toggleElement,
  displayElement,
  hideElement,
  find
} from '@fretadao/f-js-dom';
import './component.scss';

application.register(
  'search-box',
  class extends Controller {
    static targets = [
      'button',
      'direction',
      'origin',
      'destination',
      'scheduleDeparture',
      'scheduleArrival',
      'menu',
      'toggleMenu',
      'submit',
      'email',
      'form'
    ];
    static classes = ['active'];

    connect() {
      if (this.hasScheduleArrivalTarget) new Cleave('#schedule_arrival', {time: true, timePattern: ['h', 'm']});
      if (this.hasScheduleArrivalTarget) new Cleave('#schedule_departure', {time: true, timePattern: ['h', 'm']});
      if (this.hasDirectionTarget) this.scheduleFormatChange(this.directionTarget.value);
    }

    updateDirection(event) {
      let selectedButton = event.currentTarget;
      this.activeSelectedButton(selectedButton);

      const selectedDirection = selectedButton.dataset.value;
      let currentDirection = this.directionTarget.value;

      if ((selectedDirection !== currentDirection)) {
        this.handleDirectionChange(selectedDirection, currentDirection);
      }

      this.directionTarget.value = selectedDirection;

      let dropdownDirection = this.directionTarget;

      if (dropdownDirection) {
        dropdownDirection.value = selectedDirection;
      }
    }

    activeSelectedButton(selectedButton) {
      removeClass(this.buttonTargets, this.activeClass);
      addClass(selectedButton, this.activeClass);
    }

    submit(_e) {
      const isSelectDirection = this.destinationTarget.type == 'select-one';
      const form = this.formTarget;

      if (this.directionTarget.value === 'outgoing' && isSelectDirection) {
        this.originTarget.setAttribute('name', 'b');
        this.destinationTarget.setAttribute('name', 'all');
        find('#all').setAttribute('name', 'bll');
      }

      if(this.hasFormTarget && form.checkValidity()) form.submit();
    }

    handleDirectionChange(selectedDirection, currentDirection) {
      const isSelectDirection = this.destinationTarget.type == 'select-one';
      const involvesOutgoingDirection = selectedDirection === 'outgoing' || currentDirection === 'outgoing';

      if (involvesOutgoingDirection && isSelectDirection) {
        this.updatePlaceholder(selectedDirection);
        this.swapAddressFields();
      }

      this.scheduleFormatChange(selectedDirection);
    }

    scheduleFormatChange(selectedDirection) {
      if (!this.hasScheduleArrivalTarget && !this.hasScheduleDepartureTarget) return;

      if (selectedDirection === 'ingoing') {
        displayElement(this.scheduleArrivalTarget);
        hideElement(this.scheduleDepartureTarget);
        this.scheduleArrivalTarget.style.width = '100%';
      } else if (selectedDirection === 'outgoing') {
        hideElement(this.scheduleArrivalTarget);
        displayElement(this.scheduleDepartureTarget);
        this.scheduleDepartureTarget.style.width = '100%';
      } else {
        displayElement(this.scheduleArrivalTarget);
        displayElement(this.scheduleDepartureTarget);
        this.scheduleArrivalTarget.style.width = '45%';
        this.scheduleDepartureTarget.style.width = '45%';
      }
    }

    updatePlaceholder(selectedDirection) {
      const originPlaceholder = 'Endereço de origem';
      const destinationPlaceholder = 'Endereço de destino';

      if (selectedDirection === 'outgoing') {
        this.originTarget.placeholder = destinationPlaceholder;
        this.destinationTarget.placeholder = originPlaceholder;
      } else {
        this.originTarget.placeholder = originPlaceholder;
        this.destinationTarget.placeholder = destinationPlaceholder;
      }
    }

    swapAddressFields() {
      this.swapNodes(this.destinationTarget, this.originTarget.parentNode);
    }

    swapNodes(node1, node2) {
      const afterNode2 = node2.nextElementSibling;
      const parent = node2.parentNode;

      node1.replaceWith(node2);
      parent.insertBefore(node1, afterNode2);
    }

    selectUpdated() {
      this.scheduleFormatChange(this.directionTarget.value);
    }

    toggleSearchBoxMobile() {
      let toggleButton = find(".SearchFilter-toggleBt", this.element);

      toggleElement(toggleButton);
      toggleClass(this.menuTarget, 'hidden');

      if (this.hasDirectionTarget) {
        this.scheduleFormatChange(this.directionTarget.value);
      }
    }

    invert() {
      let a = this.originTarget.value;
      let b = this.destinationTarget.value;

      this.destinationTarget.value = a;
      this.originTarget.value = b;

      let all = find('#all').value;
      let bll = find('#bll').value;

      find('#bll').value = all;
      find('#all').value = bll;

      if (this.directionTarget.value) {
        if (this.directionTarget.value == 'ingoing') {
          this.handleDirectionChange('outgoing', 'ingoing');
          this.directionTarget.value = 'outgoing';
        } else if (this.directionTarget.value == 'outgoing') {
          this.handleDirectionChange('ingoing', 'outgoing');
          this.directionTarget.value = 'ingoing';
        }
      }

      this.buttonTargets.map(btn => {
        if (btn.dataset.value === this.directionTarget.value) {
          this.activeButton = btn;
        }
      });

      this.activeSelectedButton(this.activeButton);

      let searchButton = find('#searchButton');
      searchButton.click();
    }
  }
);
